// Cuts a clip-path hole in a fullscreen dialog scrim so the teacher tools pill stays clickable
export function useTeacherToolsScrimClip(dialogSelector: string, layerSelector = ".v-overlay__scrim") {
  let observer: ResizeObserver | null = null
  let handler: (() => void) | null = null

  function clipScrim() {
    const scrim = document.querySelector(`${dialogSelector} ${layerSelector}`) as HTMLElement
    const tools = document.querySelector(".teacher-tools") as HTMLElement
    if (!scrim || !tools) { return }

    const rect = tools.getBoundingClientRect()
    const r = Math.min(25, rect.width / 2, rect.height / 2)
    const { left: x, top: y, width: w, height: h } = rect

    const hole = `M ${x + r} ${y} A ${r} ${r} 0 0 0 ${x} ${y + r} L ${x} ${y + h - r} A ${r} ${r} 0 0 0 ${x + r} ${y + h} L ${x + w - r} ${y + h} A ${r} ${r} 0 0 0 ${x + w} ${y + h - r} L ${x + w} ${y + r} A ${r} ${r} 0 0 0 ${x + w - r} ${y} Z`
    const outer = "M 0 0 L 100000 0 L 100000 100000 L 0 100000 Z"

    scrim.style.clipPath = `path('${outer} ${hole}')`
  }

  function startScrimClipObserver() {
    stopScrimClipObserver()
    handler = () => clipScrim()
    observer = new ResizeObserver(handler)
    observer.observe(document.documentElement)

    const tools = document.querySelector(".teacher-tools")
    if (tools) {
      observer.observe(tools)
    }
    window.addEventListener("resize", handler)
  }

  function stopScrimClipObserver() {
    if (observer) {
      observer.disconnect()
      observer = null
    }
    if (handler) {
      window.removeEventListener("resize", handler)
      handler = null
    }
  }

  return { startScrimClipObserver, stopScrimClipObserver }
}
